import sliderTestimonials from '../../../../../../src24/js/modules/sliderTestimonials';

window.addEventListener('load', () => {
    sliderTestimonials.init();
});
